<script>
  export default {
    name: 'Modal',
    inheritAttrs: false,
    emits: ['confirm', 'cancel'],
    props: {
      showClose: {
        type: Boolean,
        default: true
      },
    }
  }
</script>

<template>
  <vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal-container" content-class="modal-content">
    <span class="modal__title">
      <slot name="title"></slot>
    </span>
    <div class="modal__content">
      <slot :params="params"></slot>
    </div>
    <div class="modal__action">
      <button @click="$emit('confirm', close)" class="button button_dark mr-2">{{ $t('modal.continue') }}</button>
      <button @click="$emit('cancel', close)" class="button button_dark" v-if="showClose">{{ $t('modal.cancel') }}</button>
    </div>
    <button class="button button_icon modal__close" @click="close">
      <img src="@/images/img/close.png" alt="">
    </button>
  </vue-final-modal>
</template>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep(.modal-content) {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  max-height: 90%;
  margin: 0 auto;
  padding: 1rem;
  border: none;
  border-radius: 0;
  background: var(--light-base);
  max-width: 600px;
  color: var(--medium-base);
}
.modal__title {
  margin: 0 2rem 0 0;
  font-size: 1.5rem;
  font-weight: 700;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
@media (max-width: 767px) {
  ::v-deep(.modal-content) {
    max-width: 80%;
  }
}
</style>

<style scoped>
.dark-mode div ::v-deep(.modal-content) {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
